import { useEffect, useState } from 'react';

import { localStorage } from '../../utils/storage/storage';
import { isArrayWithLength } from '../../utils/validators/validators';

import {
  RECENT_VEHICLES_LS_KEY,
  SHOULD_REFRESH_USER_ON_APP_LOAD
} from '../../../shared/constants/storage-keys';

function useSmartLoader() {
  const [shouldLoadComponent, setShouldLoadComponent] = useState(() => {
    const isLoggedIn = localStorage(SHOULD_REFRESH_USER_ON_APP_LOAD);
    const recentVehicles = localStorage(RECENT_VEHICLES_LS_KEY);

    return isLoggedIn || isArrayWithLength(recentVehicles);
  });

  useEffect(() => {
    // TODO: Once lightweight JIT Fitment and MyAccount Providers and Hooks are added we can replace this
    const checkStorage = e => {
      const storageKey = e?.detail?.key;

      if (
        storageKey === SHOULD_REFRESH_USER_ON_APP_LOAD ||
        storageKey === RECENT_VEHICLES_LS_KEY
      ) {
        setShouldLoadComponent(true);
      }
    };

    window.addEventListener('setStorageItem', checkStorage, false);
    return () => {
      window.removeEventListener('setStorageItem', checkStorage, false);
    };
  }, [setShouldLoadComponent]);

  return {
    setShouldLoadComponent,
    shouldLoadComponent
  };
}

export default useSmartLoader;
